import apiService from './apiService';

export async function fetchEconsultPreferences() {
  const response = await apiService.get('users/selfserve/settings/econsult');
  return response?.data;
}
